import React from 'react';
import {connect} from "react-redux";
import * as companyActions from "../../actions/company";
import * as countryActions from "../../actions/country";
import * as utils from "../../utils/underwriter";
import l10n from "../../l10n/localization";
import SelectCountries from "./fields/SelectCountries";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/underwriter';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class CompanyForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item : null,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.underwriter.name,
                    },
                    rebateRate: {
                        type: "number",
                        title: l10n.underwriter.rebateRate,
                    },
                    country: {
                        type: "string",
                        title: l10n.common.country,
                    },
                    address: {
                        type: "string",
                        title: l10n.client.address
                    },
                }
            },
            uiSchema: {
                name: {
                    "ui:emptyValue": ""
                },
                rebateRate: {
                    "ui:widget": "hidden",
                    "ui:emptyValue": 0
                },
                address: {
                    "ui:widget": "textarea",
                    "ui:options": {
                        rows: 10
                    },
                    "ui:emptyValue": ""
                },
                country: {
                    "ui:field": "selectCountries",
                },
            },
            fields: {
                selectCountries: SelectCountries,
            },
            isDirty: false,
            formData: utils.underwriterToForm(utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item : null)
        };
    }

    componentDidMount() {
        this.props.dispatch(countryActions.fetchCountries());
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(companyActions.edit(form));
                });
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(companyActions.edit(form));
                });
            }
        } else {
            form.isUnderwriter = false;
            this.setState({item: formData}, () => {
                this.props.dispatch(companyActions.add(form, true));
            });
        }
        this.setState((state) => {return {...state, isDirty: false, formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(companyActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        if (this.props.loading || this.props.loadingCurrencies) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'company-form dirty':'company-form';

        return (
            <div className={formClassName}>
                <h1>Company</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    onSubmit={this.onSubmit}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onError={this.handleError}
                    fields={this.state.fields} >
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.company.loading,
        loadingCurrencies: state.currency.loading,
        saving: state.company.saving,

        newlyCreatedElement: state.creation.newlyCreatedCompany,
    });
})(CompanyForm);



// WEBPACK FOOTER //
// ./src/components/forms/CompanyForm.js